import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import CreateBorrowerProfile from '../components/CompleteProfile/CreateBorrowerProfile';
import CreateProviderProfile from '../components/CompleteProfile/CreateProviderProfile';
import { UserTypeId } from '../helpers/constants';
import history from '../helpers/history';
import { RootState } from '../states/reducers';

const CompleteProfilePage = () => {
  // TODO: If no foundUser, redirect to login page, or refresh tokens.
  // To test code as is, create a dummy user with a typeId.

  const { auth } = useSelector((state: RootState) => state);
  const userTypeId = auth.authUser?.user.user_type_id;

  const renderComponent = useCallback(() => {
    if (userTypeId === UserTypeId.BORROWER) {
      return <CreateBorrowerProfile />;
    } else if (userTypeId === UserTypeId.SERVICE_PROVIDER) {
      return <CreateProviderProfile />;
    } else if (userTypeId === UserTypeId.INVESTOR) {
      return history.push('/dashboard') as any;
    } else {
      history.push('/404') as any;
    }
  }, [userTypeId]);

  return renderComponent();
};

export default CompleteProfilePage;
